import { useAuthenticator } from "@aws-amplify/ui-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { putCapitalizationComplete } from "../utility/putCapitalizationComplete";
import { useAuth } from "../../context/AuthContext";

interface ChatCompleteConfirmDialogProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  conversationDate?: string;
}

export const ChatCompleteConfirmDialog: React.FC<
  ChatCompleteConfirmDialogProps
> = ({ isOpen, setIsOpen, conversationDate }) => {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const { idToken, refreshAuthSession } = useAuth();

  // チャットの終了処理
  const chatCompleteButtonClicked = () => {
    if (!conversationDate) return;
    if (!idToken) return;
    // conversationIdからメタデータをCompleteにする
    putCapitalizationComplete(user.userId, conversationDate, idToken);

    setIsOpen(false);
    // 事後アンケートへ飛ぶ
    navigate("/post-questionnaire", {
      state: { date: conversationDate },
    });
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle>会話を終了する</DialogTitle>
      <DialogContent>
        <DialogContentText>
          本日の会話を終了します。よろしいですか？
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsOpen(false)}>キャンセル</Button>
        <Button onClick={chatCompleteButtonClicked}>終了する</Button>
      </DialogActions>
    </Dialog>
  );
};
